/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getAccountInfo.defs.js'
export { main as default } from './getAccountInfo.defs.js'
